import React, { Component } from 'react';

import ApiUrls from '../../services/apiUrls';
import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import { KuposErrorSuccessModal } from '.';
import { NewsLetterSuccessModal } from './NewsLetterSuccessModal';
import PropTypes from 'prop-types';
import i18next from 'i18next';

export default class KuposFooter extends Component {
	static propTypes = {
		t: PropTypes.func,
		history: PropTypes.object,
		metaData: PropTypes.object,
		actions: PropTypes.object,
		ticketDetails: PropTypes.object,
		serviceList: PropTypes.object,
	};
	constructor(props) {
		super(props);
		this.state = {
			newsLetterModal: false,
		};
	}

	gotoHome = () => {
		window.scrollTo(0, 0);
		if (CommonService.clearSearchFunction) {
			CommonService.clearSearchFunction();
		}
		this.props.actions.setOnwardPbDate(DateService.getTodayString());
		this.props.actions.setReturnPbDate(null);
		this.props.actions.pbSetSourceCity(null);
		this.props.actions.pbSetDestinationCity(null);
		this.props.actions.setServiceListOnward(null);
		this.props.actions.setServiceListReturn(null);
		if (this.props.history) this.props.history.push('/');
	};

	subscribe = () => {
		if (!this.state.email) {
			this.setState({
				emailError: 'VALIDATIONS.VALID_EMAIL',
			});
			return;
		} else if (!CommonService.isEMailValid(this.state.email)) {
			this.setState({
				emailError: 'VALIDATIONS.VALID_EMAIL_VALIDATION',
			});
			return;
		}
		this.props.actions
			.subscribe({ url: ApiUrls.subscribe(), data: { email: this.state.email } })
			.then(
				res => {
					if (res.data && res.data.status === 200) {
						this.setState({ newsLetterModal: true });
					} else if (res.data) {
						this.setState({
							newsLetterFailureModal: true,
							newsLetterFailureModalMessage: res.data.error,
						});
					}
				},
				err => { },
			);
	};

	renderFooter = (t, history, operator) => {
		if (operator && operator.footer_type === 1) {
			return (
				<div
					className="kupos-footer-main"
					style={
						this.props.ticketDetails && this.props.ticketDetails === 'no data'
							? { marginTop: '70vh' }
							: null
					}
				>
					<div
						className="kupos-footer"
						style={{
							background: operator.background_color,
							paddingBottom: '0',
						}}
					>
						<div className=" content-container">
							<div
								className="last-footer font10"
								style={{
									background: 'none',
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									padding: '20px 0',
								}}
							>
								<div
									className="footer-logo"
									style={{ cursor: 'pointer' }}

								// onClick={() => window.open(operator.domain_url, '_parent', '', true)}
								>
									<a href="/">
										<img
											src={operator.footer_logo}
											// alt={this.props.t('TRANSLATIONS.VIATUR_LOGO')}
											style={{
												marginTop: '0',
												width: operator.footer_logo_width,
												height: 'auto',
											}}
										/>
									</a>
								</div>
								<div style={{ color: operator.text_color }}>
									<span className="d-flex bold-text">{operator.title.split('|')[0]}2021.</span>
									<span className="d-flex bold-text my-2">Todos los derechos reservados ©</span>
									<span className="d-flex bold-text">
										Powered by
										<span
											style={{ cursor: 'pointer', marginLeft: '5px' }}
											onClick={() => window.open('https://www.kupos.cl', '_parent')}
										>
											kupos.cl
										</span>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		} else if (operator && operator.footer_type === 2) {
			return (
				<div
					className="kupos-footer-main"
					style={
						this.props.ticketDetails && this.props.ticketDetails === 'no data'
							? { marginTop: '70vh' }
							: null
					}
				>
					<div
						className="kupos-footer"
						style={{
							background: operator.theme_color,
							paddingBottom: '0',
						}}
					>
						<div className=" content-container">
							<div
								className="last-footer font10"
								style={{
									background: 'none',
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
									alignItems: 'center',
									padding: '20px 0',
								}}
							>
								<div className="footer-logo" style={{ cursor: 'pointer' }}>
									<a href="/">
										<img
											src={operator.footer_logo}
											// alt={this.props.t('TRANSLATIONS.VIATUR_LOGO')}
											style={{
												marginTop: '0',
												width: operator.footer_logo_width,
												height: 'auto',
											}}
										/>
									</a>
								</div>

								<div style={{ margin: '22px 0' }}>
									{operator.show_header_links && operator.header_links
										? operator.header_links.map((val, i) => {
											return (
												<span>
													<a
														style={{ color: operator.text_color, fontSize: '16px' }}
														href={Object.values(val)}
													>
														{Object.keys(val)}
													</a>
													{i < operator.header_links.length - 1 ? (
														<span style={{ color: operator.text_color, margin: '0 10px' }}>
															|
														</span>
													) : (
														''
													)}
												</span>
											);
										})
										: null}
								</div>

								<div style={{ color: operator.text_color }}>
									<div>
										<div style={{ fontSize: '13px', display: 'flex', alignItems: 'center' }}>
											<span style={{ display: 'flex', alignItems: 'center' }}>
												<img
													src="/svgs/phone.svg"
													alt="DIS"
													style={{ height: '20px', width: '20px', marginRight: '3px' }}
												// className="logo"
												// id="main-logo"
												// alt={this.props.t('TRANSLATIONS.MAIN_LOGO')}
												/>
												(+56 9) 4915 6683
											</span>
											<span style={{ margin: '0 10px' }}>|</span>
											<span style={{ display: 'flex', alignItems: 'center' }}>
												<img
													src="/svgs/email-icon.svg"
													alt="DIS"
													style={{ height: '20px', width: '20px', marginRight: '3px' }}

												// className="logo"
												// id="main-logo"
												// alt={this.props.t('TRANSLATIONS.MAIN_LOGO')}
												/>
												ayuda@pasajebus.com
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>

						{operator.show_bottom_footer ? (
							<div
								className="kupos-footer"
								style={{
									background: operator.color_codes ? operator.color_codes.secondary_color : '',
									paddingBottom: '0',
								}}
							>
								<div className=" content-container">
									<div
										className="last-footer font10"
										style={{
											background: 'none',
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											padding: '5px',
											color: operator.text_color,
											fontSize: '11px',
										}}
									>
										<a href="/" style={{ color: operator.text_color }}>
											ANDIMAR 2023
										</a>
										- Todos los derechos reservados © | Mapa del sitio | Powered by
										<a
											href="https://www.kupos.cl"
											style={{ marginLeft: '5px', color: operator.text_color }}
										>
											kupos.cl
										</a>
									</div>
								</div>
							</div>
						) : null}
					</div>
				</div>
			);
		}
		return null;

		//  else {
		//   return <div className="kupos-footer-main">
		//     <div className="kupos-footer">
		//       <div className=" content-container">
		//         <div className="footer-logo" onClick={this.gotoHome}>
		//           <img src="/svgs/kupos-logo2.svg" alt={this.props.t('TRANSLATIONS.KUPOS_LOGO2')} />
		//         </div>

		//         <div className="footer-details">
		//           <div className="individual-footer-details">
		//             <div className="individual-footer-item font10">
		//               <span className="bold-footer-item bold-text font14">{t('HOME.OUR_COMPANY')}</span>
		//               <div
		//                 className="underline"
		//                 onClick={() => history.push(`/${i18next.language}/pages/about`)}
		//               >
		//                 {t('HOME.ABOUT_KUPOS')}
		//               </div>
		//               <div
		//                 className="underline"
		//                 onClick={() => history.push(`/${i18next.language}/pages/partners`)}
		//               >
		//                 {t('HOME.OUR_PARTNERS')}
		//               </div>
		//               <div
		//                 className="underline"
		//                 onClick={() => history.push(`/${i18next.language}/pages/our-investors`)}
		//               >
		//                 {t('HOME.OUR_INVESTORS')}
		//               </div>
		//               <div className="underline">{t('HOME.CARRERS')}</div>
		//               <div
		//                 className="underline"
		//                 onClick={() => history.push(`/${i18next.language}/pages/press`)}
		//               >
		//                 {t('HOME.PRESS')}
		//               </div>
		//               <div
		//                 className="underline"
		//                 onClick={() => history.push(`/${i18next.language}/pages/contact`)}
		//               >
		//                 {t('HOME.CONTACT_US')}{' '}
		//               </div>
		//             </div>

		//             <div className="individual-footer-item font10">
		//               <span className="bold-footer-item bold-text font14">
		//                 {t('HOME.USEFUL_DETAILS')}
		//               </span>

		//               <div
		//                 className="underline"
		//               // onClick={() => history.push(`https://kupos.zendesk.com/hc/es`)}
		//               >
		//                 <a href="https://kupos.zendesk.com/hc/es">{t('HOME.FAQ')}</a>
		//               </div>
		//               <div
		//                 className="underline"
		//                 onClick={() => history.push(`/${i18next.language}/pages/tnc`)}
		//               >
		//                 {t('HOME.TNC')}{' '}
		//               </div>
		//               <div
		//                 className="underline"
		//                 onClick={() => history.push(`/${i18next.language}/pages/privacy-policy`)}
		//               >
		//                 {t('HOME.PRIVACY_POLICY')}{' '}
		//               </div>
		//               <div
		//                 className="underline"
		//                 onClick={() => history.push(`/${i18next.language}/pages/travel-agency`)}
		//               >
		//                 {t('HOME.TRAVEL_AGENCY')}{' '}
		//               </div>
		//               <div
		//                 className="underline"
		//                 onClick={() => history.push(`/${i18next.language}/site-map`)}
		//               >
		//                 {t('HOME.SITEMAP')}
		//               </div>
		//             </div>

		//             <div className="individual-footer-item subscribe-n-social">
		//               <div className="subscribe-div">
		//                 <span className="bold-footer-item bold-text font14">
		//                   {t('HOME.NEWSLETTER')}
		//                 </span>
		//                 <div className="footer-news-letter-input flex-row font10">
		//                   <input
		//                     className="font10"
		//                     type="email"
		//                     placeholder={t('PASSENGER_DETAILS.EMAIL_ID')}
		//                     value={this.state.email}
		//                     onChange={event =>
		//                       this.setState({ email: event.target.value.trim(), emailError: null })
		//                     }
		//                     onBlur={event => this.setState({ email: event.target.value })}
		//                   />
		//                   <button
		//                     onClick={this.subscribe}
		//                     className="kupos-button no-decoration"
		//                     disabled={this.props.subscribePending ? true : false}
		//                   >
		//                     {this.props.subscribePending ? (
		//                       <div className="loader-cricle"></div>
		//                     ) : (
		//                       <span>{t('HOME.SEND')}</span>
		//                     )}
		//                   </button>
		//                 </div>
		//                 {this.state.emailError ? (
		//                   <div style={{ marginTop: -5 }} className="errorMessageInput font8">
		//                     {t(this.state.emailError)}
		//                   </div>
		//                 ) : null}
		//               </div>

		//               <div className="div-social-media-icons">
		//                 <div className="social-icons-footer">
		//                   <div className="footer-social-image">
		//                     {this.props.metaData ? (
		//                       <a
		//                         href={this.props.metaData.social_media_urls.facebookUrl}
		//                         target="_blank"
		//                       >
		//                         <img
		//                           src="/static/images/icons/home/icon-facebook.png"
		//                           alt={this.props.t('TRANSLATIONS.FB')}
		//                         />
		//                       </a>
		//                     ) : null}
		//                   </div>
		//                   <div className="footer-social-image">
		//                     {this.props.metaData ? (
		//                       <a href={'https://www.instagram.com/pasajebus/'} target="-blank">
		//                         <img
		//                           src="/static/images/icons/home/icon-instagram.png"
		//                           alt={this.props.t('TRANSLATIONS.INSTA')}
		//                         />
		//                       </a>
		//                     ) : null}
		//                   </div>
		//                   <div className="footer-social-image">
		//                     {this.props.metaData ? (
		//                       <a
		//                         href={this.props.metaData.social_media_urls.twitterUrl}
		//                         target="_blank"
		//                       >
		//                         <img
		//                           src="/static/images/icons/home/icon-twitter.png"
		//                           alt={this.props.t('TRANSLATIONS.TWITTER')}
		//                         />
		//                       </a>
		//                     ) : null}
		//                   </div>
		//                   <div className="footer-social-image">
		//                     {this.props.metaData ? (
		//                       <a href={this.props.metaData.social_media_urls.blogUrl} target="_blank">
		//                         <img
		//                           src="/static/images/icons/home/icon-blog.png"
		//                           alt={this.props.t('TRANSLATIONS.BLOG')}
		//                         />
		//                       </a>
		//                     ) : null}
		//                   </div>
		//                 </div>
		//               </div>
		//             </div>
		//           </div>
		//         </div>
		//       </div>
		//     </div>

		//     <div className="last-footer font10">
		//       <span className="copyright-message">{t('HOME.FOOTER_COPYRIGHT')}</span>
		//     </div>

		//     <NewsLetterSuccessModal
		//       showModal={this.state.newsLetterModal}
		//       onHide={() => this.setState({ newsLetterModal: false })}
		//       t={this.props.t}
		//     />
		//     <KuposErrorSuccessModal
		//       onHide={() => this.setState({ newsLetterFailureModal: false })}
		//       showModal={this.state.newsLetterFailureModal}
		//       success={false}
		//       bodyText={this.state.newsLetterFailureModalMessage}
		//     />
		//   </div>
		// }
	};

	render() {
		const { t, history } = this.props;
		const operator = CommonService.getLocal('op');

		return this.renderFooter(t, history, operator);
	}
}



// WEBPACK FOOTER //
// ./src/features/common/KuposFooter.js